import { useRouter } from 'next/router'
import { useEffect } from 'react'
import ExtensionInstallBanner from '~/src/components/ExtensionInstallBanner'
import Layout from '~/src/components/Layout'
import LottiePlayer from '~/src/components/LottiePlayer'
import { useAppContext } from '~/src/context/AppProvider'
import useAuthUser from '~/src/hooks/useAuthUser'
import useGetTempUserId from '~/src/hooks/useGetTempUserId'
import useShowIntercom from '~/src/hooks/useShowIntercom'

interface Props {
  statusCode?: number
  title?: string
  subtitle?: string
}

const ErrorPage: React.FC<Props> = ({
  statusCode,
  title,
  subtitle = "Looks like we're having issues, we're sorry",
}) => {
  const router = useRouter()
  const asPath = router.asPath
  const error = statusCode ? `${statusCode} Error` : title || 'Error'
  const { hash } = useAppContext()
  const { authUser } = useAuthUser()
  const { tempUserId } = useGetTempUserId()

  const { enableIntercom } = useShowIntercom({
    customAttributes: {
      hash,
      tempUserId,
      userId: authUser?.uid,
      path: asPath,
      error,
    },
  })

  // Enable Intercom
  useEffect(() => {
    enableIntercom()
  }, [enableIntercom])

  return (
    <Layout
      nextSeo={{
        title: title || 'Error',
        noindex: true,
        nofollow: true,
      }}
      hideTryIt
    >
      <div className='w-full space-y-10 pt-8 dark:bg-black'>
        <div className='mx-auto flex max-w-sm flex-col items-center space-y-4 px-4 text-center'>
          <LottiePlayer
            src='https://lottie.host/b8dd671a-be70-4d9c-801c-93b54cc8fd5a/rATEr3c9ql.lottie'
            loop
            autoplay
            style={{
              height: 100,
              width: 100,
            }}
          />
          <h1 className='max-w-md text-center text-xl font-bold'>{error}</h1>
          <h2 className='max-w-md text-center text-4xl font-black'>
            {subtitle}
          </h2>
        </div>
        <ExtensionInstallBanner appStoreCampaign='ErrorPageBottomBanner' />
      </div>
    </Layout>
  )
}

export default ErrorPage
